import { Link } from 'gatsby';
import React from 'react';
import { Box, Button } from 'theme-ui';
import ArrowRight from '~/assets/images/icons/arrow-right.svg';

export const PdpButton = ({ url, linkText }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '5.2rem',
        alignItems: 'center',
        justifyContent: 'center',
        mb: '5rem',
        display: ['none', 'none', 'flex'],
      }}
    >
      <Button
        as={Link}
        to={url}
        sx={{
          color: 'alizarinCrimson',
          border: `1px solid #CF2029`,
          borderRadius: '1rem',
          fontSize: '1.8rem',
          fontWeight: 'bold',
          alignItems: 'center',
          justifyContent: 'center',
          p: '1.5rem 3rem ',
          svg: {
            width: '2rem',
            height: '100%',
            ml: '1rem',
          },
        }}
      >
        {linkText}
        <ArrowRight />
      </Button>
    </Box>
  );
};
